import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var TextListItemVariants;

(function (TextListItemVariants) {
  TextListItemVariants["li"] = "li";
  TextListItemVariants["dt"] = "dt";
  TextListItemVariants["dd"] = "dd";
})(TextListItemVariants || (TextListItemVariants = {}));

export var TextListItem = function TextListItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? TextListItemVariants.li : _a$component,
      props = __rest(_a, ["children", "className", "component"]);

  var Component = component;
  return React.createElement(Component, Object.assign({}, props, {
    "data-pf-content": true,
    className: css(className)
  }), children);
};